import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { OpdateringNoter } from './opdateringNoter';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OpdateringNoterService } from './opdatering-noter.service';

@Component({
    selector: 'app-opdatering-noter',
    templateUrl: './opdatering-noter.component.html',
    styleUrls: ['./opdatering-noter.component.scss'],
    standalone: false
})
export class OpdateringNoterComponent implements AfterViewInit {
    @Input() showFooter: boolean;
    @Input() noter: OpdateringNoter[] = [];

    @ViewChild('laterButton', { static: false }) laterButton: ElementRef<HTMLButtonElement>;

    constructor(
        private activeModal: NgbActiveModal,
        private opdateringNoterService: OpdateringNoterService
    ) { }

    ngAfterViewInit(): void {
        this.laterButton?.nativeElement.focus();
    }

    onDismiss() {
        this.activeModal.dismiss();
    }

    markAllRead() {
        this.opdateringNoterService.postLaeste(this.noter.map(n => n.id)).subscribe();
        this.activeModal.dismiss();
    }
}
